import { formatDate } from '@fullcalendar/core'

const classDates = [
	'01-13',
	'01-18',
	'01-20',
	'01-23',
	'01-25',
	'01-27',
	'01-30',
	'02-01',
	'02-03',
	'02-06',
	'02-08',
	'02-10',
	'02-13',
	'02-15',
	'02-17',
	'02-20',
	'02-22',
	'02-27',
	'03-01',
	'03-03',
	'03-06',
	'03-08',
	'03-10',
	'03-20',
	'03-22',
	'03-24',
	'03-27',
	'03-29',
	'03-31',
	'04-03',
	'04-05',
	'04-07',
	'04-10',
	'04-12',
	'04-17',
	'04-19',
	'04-21',
	'04-24',
	'04-26',
	'04-28'
].map(x=>'2023-'+x);

const presentationDates = [
	'03-06',
	'03-08',
	'03-10',
	'03-27',
	'03-29',
	'03-31',
	'04-10',
	'04-12',
	'04-24',
	'04-26',
	'04-28'
].map(x=>'2023-'+x);

const examPeriod = [
	'05-03',
	'05-04',
	'05-05',
	'05-08',
	'05-09'
].map(x=>'2023-'+x);


const breakDays = [
	'02-23',
	'02-24',
	'03-13',
	'03-14',
	'03-15',
	'03-16',
	'03-17'
].map(x=>'2023-'+x);

const RAPSday = [
	'04-14'
].map(x=>'2023-'+x);

const papersDue = [
	'04-30'
].map(x=>'2023-'+x+'T15:50');

const midtermGiven = [
	'02-21'
].map(x=>'2023-'+x+'T15:50');

const midtermDue = [
	'02-28'
].map(x=>'2023-'+x+'T15:50');

const classesCancelled = [
	'01-16'
].map(x=>'2023-'+x);

const linkto = (x,y) => `<a href="${y}"><i>${x}</i></a>`

const modules = [
	{title: "Introduction",
	readings: [
		[	]
		]
	},
	{title: "The Method of Cases", 
	readings: [
		[],
		[`<i>optional</i>: Peter Singer, ${linkto("Famine, Affluence, and Morality", "https://personal.lse.ac.uk/robert49/teaching/mm/articles/Singer_1972Famine.pdf")}`],    // Singer, poverty
		// I think these classes went really well.  The first assignment I gave them was maybe too confusing.  Maybe structure to show what a moral principle is and then what a moral intuition or judgment is.  (Principles are justifications that apply across a variety of cases.)
		],
	slides: [
		`01-meat`,
		`02-charity`
	]
	},
	{title: "Metaethics", 
	readings: [
		[`Vaughn, chapter 1`],
		[`<i>optional</i>: Vaughn, chapter 5`], // I mostly liked these metaethics classes but I could tell they bored/ lost some kids.  Just buckle in and make one on relativism, but clean it up.  Move the Gyges ring stuff maybe to egoism section?  Not sure the god stuff went great; could get rid of it.  I think I might prefer: first class on what moral theories are, then do relativism and emphasize that they probably have second-order relativism beaten into them but are objectivists about first-order moral judgments.  Maybe mention that the distinction between fact and opinion is garbage. Then second class, do Egoism.  Start w psychological egoism and do ring of Gyges, then the Joey argument.  Egoism could act as a false first moral theory to consider and it's almost like a form of utilitarianism.
		],
	slides: [
		`03-intro-concepts`,
		`04-metaethics`
	]
	},
	{title: "Utilitarianism", 
	readings: [
		[`Vaughn, chapter 4`], // WHAT IS HEDONIC ACT UTILITARIANISM? Move the "how to choose a moral theory stuff" maybe to end of module?  Bring in stuff about impartiality from next class.  Maybe ease up on the stuff about 
		[`Vaughn, chapter 6`], // APPLICATION this class ended up being almost entirely about capital punishment... I would really make this the focus next time!  Let's try to apply utilitarianism to a real-world case.  Print up some work sheets with two halves (and a scale in the middle: features of capital punishment that would increase happiness for someone, features that decrease happiness for someone).  Have them fill them out alone, then agglomerate, then class discussion on board.  The way the class progressed went really well: in both sections I got a bunch of pro-happiness things that I could later circle than rebuke.  Inclusions: It's cheaper (it's actually ten times as expensive), happiness to victims' families (you can't bring them back, no one really reports happiness), prevents suffering of life imprisonment (but inmates don't typically choose to die), deterrence is the big one (more than life imprisonment?  Unclear.)  Empahsize other side: punishment is always a negative for a utilitarian, requires big expected positive.
		// Move the
		[`Ursula K. LeGuin, ${linkto("The Ones Who Walk Away From Omelas", "https://shsdavisapes.pbworks.com/f/Omelas.pdf")}`, `<i>optional</i>: Krister Bykvist, ${linkto("Utilitarianism: A Guide for the Perplexed, chapters 7 and 8", "/assets/Bykvist78.pdf")}`], // Problems with utilitarianism.  Also introduce RULE utilitarianism.
		[`Robert Nozick, ${linkto("excerpts on happiness","https://rintintin.colorado.edu/~vancecd/phil3160/Nozick1.pdf")}`, `<i>optional</i>: ${linkto("The Happiness Lab Podcast, Season 1 Episode 2: The Unhappy Millionaire","https://www.happinesslab.fm/season-1-episodes/the-unhappy-millionaire")}`]   // happiness, higher pleasures, other forms of utilitarianism
		],
		slides: [
		`05-utilitarianism-1`,
		`06-utilitarianism-2`,
		`07-utilitarianism-3`,
		`08-utilitarianism-4`
	]
	},
	{title: "Deontology", 
	readings: [
		[`Vaughn, chapter 7`],   // textbook, groundwork 1
		[`Immanuel Kant, ${linkto("Groundwork of the Metaphysics of Morals, selections from Section 2", "/assets/KantGMMselection.pdf")}`, `Christine Korsgaard, ${linkto("Introduction to GMM, selections", "/assets/KorsgaardGMMIntro.pdf")}`],   // groundwork 2, korsgaard
		[`<i>optional</i>: Judith Jarvis Thomson, ${linkto("The Trolley Problem", "/assets/JJThomson.pdf")}`],    // killing and letting die, trolley problem, self-driving cars
		[],  
		[]
		],
	slides: [
		`09-kant-1`,
		`10-kant-2`,
		`11-kant-3`,
		`12-kant-4`,
		`13-kant-5`
	]
	},
	{title: "Virtue Theory", 
	readings: [
		[`Vaughn, chapter 11`],
		[`Aristotle, ${linkto("Nicomachean Ethics, Book 1", "http://classics.mit.edu/Aristotle/nicomachaen.1.i.html")} and ${linkto("Book 2", "http://classics.mit.edu/Aristotle/nicomachaen.2.ii.html")}`] // Nicomachean Ethics, Book... make this on anger??
		//[`Aristotle, ${linkto("Nicomachean Ethics, Book 8", "http://classics.mit.edu/Aristotle/nicomachaen.8.viii.html")}`]	// Friendship -- replace with anger??
		],
	slides: [
		`14-virtue-1`,
		`15-virtue-2`
	]
	},
	// {title: "Existentialism", 
 // 	readings: [
	// [`Sartre, ${linkto("Existentialism as a Humanism","https://www.marxists.org/reference/archive/sartre/works/exist/sartre.htm")}`,
	// // 		`VIDEO: A 97-year-old philosopher ponders life and death: ${linkto("What Is The Point?","https://www.youtube.com/watch?v=qX6NztnPU-4")}`]
	// // 	//[`Susan Wolf, ${linkto("Happiness and Meaning: Two Aspects of the Good Life", "")}`]
	// ]
	// },
	{title: "Social Contracts", 
	readings: [
		[`Vaughn, chapter 9`, `<i>optional</i>: Rawls, ${linkto("A Theory of Justice, chapter 1, sections 1-5", "/assets/RawlsTJexcerpt.pdf")}`]
		],
	slides: [
		`16-hobbes-1`
	]
	},

	{title: "Bioethics",
	extendedtitle: "Applied Ethics 1",
	readings: [
		[`Harris, Pritchard, and Rabins, ${linkto("Engineering Ethics: Concepts and Cases (4th edition), chapter 1", "/assets/EECC4thCh1.pdf")}`],
		[],
		[`Varkey, ${linkto("Principles of Clinical Ethics and Their Application to Practice", "https://www.karger.com/Article/Pdf/509119")}`, `<i>Optional</i>: Veatch, Haddad, and English, ${linkto("Codes of Medical Ethics", "/assets/CodesMedicalEthics.pdf")}`],
		[],
		[],
		[]
		],
	slides: [
		`17-bioethics-1`,
		`18-bioethics-2`,
		`19-bioethics-3`,
		null,
		null,
		null
	]
	},
	{title: "Engineering Ethics",
	extendedtitle: "Applied Ethics 2",
	readings: [
		[`Harris et al., Engineering Ethics: Concepts and Cases, ${linkto("Responsible Engineering", "/assets/EngEthCh3.pdf")}`],
		[],
		[`Harris et al., Engineering Ethics: Concepts and Cases, ${linkto("Risk Management", "/assets/EngEthCh6.pdf")}`],
		[],
		[],
		[]
		],
	slides: [
		`20-engineering-1`,
		`21-engineering-2`,
		`22-engineering-3`,
		null,
		null,
		null
	]
	},
	{title: "Research Ethics",
	extendedtitle: "Applied Ethics 3",
	readings: [
		[`The National Academies, ${linkto("On Being a Scientist (selections)", "/assets/OnBeingaScientistSelections1.pdf")}`],
		[],
		[`Nicolas Steneck, ${linkto("Introduction to the Responsible Conduct of Research (selections)","/assets/SteneckResponsibleResearchExcerpts.pdf")}`],
		[],
		[]
		],
	slides: [
		`23-research-1`,
		`24-research-2`,
		`25-research-3`,
		null,
		null
	]
	},
	{title: "Business Ethics",
	extendedtitle: "Applied Ethics 4",
	readings: [
		[`Milton Friedman, ${linkto("The Social Responsibility of Business is to Increase Its Profits", "https://www.nytimes.com/1970/09/13/archives/a-friedman-doctrine-the-social-responsibility-of-business-is-to.html")}`,
		`Lynn Stout, ${linkto("Corporations Don't Have to Maximize Profits", "https://www.nytimes.com/roomfordebate/2015/04/16/what-are-corporations-obligations-to-shareholders/corporations-dont-have-to-maximize-profits")}`,
		`Stanford Encyclopeda of Philosophy, ${linkto("Business Ethics", "https://plato.stanford.edu/entries/ethics-business/")}, Sections 3.1, 7.1, 7.2`],
		[],
		[`Byars and Stanberry, ${linkto("Business Ethics", "https://assets.openstax.org/oscms-prodcms/media/documents/BusinessEthics-OP.pdf")}, chapter 6`],
		[],
		[],
		[]
		],
	slides: [
		`26-business-1`,
		`27-business-2`,
		`28-business-3`
	]
	},
];




const buildModuleDates = () => {
	let currClass = 0;
	const moduleDates = [];
	for (let i=0; i<modules.length; i++) {
		for (let j=0; j<modules[i].readings.length; j++) {
			moduleDates.push({
				title: modules[i].title,
				start: classDates[currClass],
				readings: modules[i].readings[j],
				modulelength: modules[i].readings.length,
				slides: modules[i].slides ? modules[i].slides[j] : null,
				firstinmodule: !j
			})
			currClass++;
		}
	}
	return moduleDates;
}


const moduleEvents = buildModuleDates();
const paperEvents = papersDue.map((x,i)=>({title: `Final Writing Project due`, start: x	}))
const paperTrueEvents = midtermGiven.map((x,i)=>({title: `Midterm distributed`, start: x	}))
const midtermEvent = midtermDue.map((x,i)=>({title: `Midterm due`, start: x	}))
const RAPSEvents = RAPSday.map((x,i)=>({title: `RAPS (no class)`, start: x	}))
const breakDayEvents = breakDays.map((x,i)=>({title:"Break Day", start: x}));
const examEvents = examPeriod.map((x,i)=>({title:"Exams", start: x}));
const cancelledEvents = classesCancelled.map((x,i)=>({title:"Class cancelled", start: x}));

if (moduleEvents.length !== classDates.length) {
	console.log(`Events: ${moduleEvents.length}.  Class dates: ${classDates.length}`)
}

export { classDates, moduleEvents, breakDayEvents, paperEvents, paperTrueEvents, RAPSEvents, examEvents, cancelledEvents, midtermEvent };